import React, { useEffect, useState } from 'react';
import { getLocale, getNovadeUrl } from '../utils/utils';
import { AppBar, CssBaseline, Toolbar, useTheme } from '@mui/material';
import logoWeb from '../assets/appbar/nl_logo_web.svg';
import logoMobile from '../assets/appbar/nl_logo_mobile.svg';
import { useIntl } from 'react-intl';
import { isMobile } from 'react-device-detect';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

/**
 * Displays the terms of use from the Novade Lite app.
 */
export const TermsOfUse = () => {
  const theme = useTheme();
  const [htmlContent, setHtmlContent] = useState('');
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );
  const intl = useIntl();

  useEffect(() => {
    const novadeUrl = getNovadeUrl();
    const filename = `${getLocale()}.html`;
    // Fetches the HTML content from the Novade Lite app.
    fetch(`${novadeUrl}/assets/assets/html/termsOfUse/${filename}`, {})
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        setHtmlContent(data);
      })
      .catch((error) => {
        console.error('Error fetching HTML content:', error);
      });
  }, []);

  useEffect(() => {
    // Resizes the HTML content to fit the screen.
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <CssBaseline />
      <AppBar
        position="sticky"
        style={{
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        <Toolbar>
          <img src={isMobile ? logoMobile : logoWeb} alt="logo" />
          <div
            className={isMobile ? 'titleLarge' : 'headlineSmall'}
            style={{ marginLeft: '8px' }}
          >
            {intl.formatMessage({
              id: 'terms_of_service.terms_of_use',
            })}
          </div>
        </Toolbar>
      </AppBar>
      <iframe
        srcDoc={htmlContent}
        width={windowDimensions.width}
        height={windowDimensions.height}
        style={{ border: 'none' }}
      ></iframe>
    </>
  );
};
